var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVipIconSteamyplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.811,
    fill: "var(--sections, white)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.811,
    stroke: "var(--featured-primary, #F46CE3)",
    strokeWidth: 0.378
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.811,
    stroke: "var(--featured-primary, #F46CE3)",
    strokeWidth: 0.378
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.297,
    stroke: "var(--featured-primary, #F46CE3)",
    strokeWidth: 0.378
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.297,
    stroke: "var(--featured-primary, #F46CE3)",
    strokeWidth: 0.378
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.164 20.336v-5.578h2.55c.51 0 .948.082 1.315.247.372.164.659.404.86.717.202.308.303.675.303 1.1 0 .42-.1.783-.303 1.091a1.985 1.985 0 01-.86.718c-.367.164-.805.247-1.315.247h-1.673l.7-.686v2.144h-1.577zm1.578-1.976l-.701-.726h1.577c.33 0 .574-.071.734-.215.164-.143.247-.342.247-.597 0-.26-.083-.462-.247-.606-.16-.143-.404-.215-.734-.215h-1.577l.7-.725v3.084zM13.465 20.336v-5.578h1.578v5.578h-1.578zM9.193 20.336l-2.382-5.578h1.705l2.008 4.829H9.52l2.056-4.83h1.562l-2.391 5.579H9.193z",
    fill: "var(--featured-primary, #F46CE3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.002 12.518l1.87 1.209-.495-2.28 1.652-1.533-2.177-.2-.85-2.15-.85 2.15-2.177.2 1.65 1.533-.494 2.28 1.87-1.21z",
    fill: "var(--featured-primary, #F46CE3)"
  })));
}
export default SvgVipIconSteamyplay;